import { LoaderIcon } from "lucide-react";
import * as React from "react";
import { cn } from "@/lib/utils";

export interface SpinnerProps extends React.ComponentProps<"svg"> {
  size?: "sm" | "md" | "lg";
  color?: "primary" | "white" | "danger" | string;
}

function Spinner({
  className,
  size = "sm",
  color,
  ...props
}: SpinnerProps): React.ReactElement {
  const sizeClasses = {
    sm: "size-5",
    md: "size-6",
    lg: "size-8",
  };

  const colorClasses: Record<string, string> = {
    primary: "text-primary",
    white: "text-white",
    danger: "text-red-500",
  };

  const sizeClass = sizeClasses[size] || "";
  const colorClass =
    color && colorClasses[color]
      ? colorClasses[color]
      : color
        ? `text-${color}`
        : "text-primary";

  return (
    <LoaderIcon
      role="status"
      aria-label="Loading"
      className={cn("animate-spin", sizeClass, colorClass, className)}
      {...props}
    />
  );
}

export { Spinner };
